<div class="flex flex-col container w-full">
    <nz-form-label nzFor="key">{{ to.label }}</nz-form-label>
    <select-autocomplete [options$]="to.options" [control]="formControl" [placeholder]="to.placeholder"></select-autocomplete>
</div>
